import { ElasticSearchResponse, Faq, FaqDocument } from '@shared/services/elastic-search/models';

export const faqsSerializer = (faqs: ElasticSearchResponse<FaqDocument>): Faq[] =>
  faqs.hits.hits.map((faq) => {
    const source = faq._source;
    return {
      url: source.url?.[0] ?? '',
      question: source.question?.[0] ?? '',
    };
  });
